<template>
  <div class="position-relative h-100 w-100">
    <div class="map-header position-absolute text-light">
      <h2 class="h3 m-0">
        <span>Day 05 - </span>Data challenge 1: OpenStreetMap
      </h2>
    </div>
    <div class="position-absolute gazetteer">
      <label for="search" class="form-label visually-hidden">Search:</label>
      <input
        class="form-control"
        type="search"
        name="search"
        placeholder="Search for a tall building or placename"
        v-model="searchTerm"
      />
      <ul class="list-unstyled bg-secondary" v-if="showResultsList">
        <li v-for="result in searchResults" :key="result.id">
          <button
            type="button"
            class="btn btn-dark w-100 text-left"
            @click="navigateTo(result)"
          >
            {{ result.place_name }}
          </button>
        </li>
      </ul>
    </div>

    <div ref="map-root" class="basemap"></div>
  </div>
</template>

<script>
import axios from "axios";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/src/css/mapbox-gl.css";

export default {
  data() {
    return {
      accessToken:
        "pk.eyJ1Ijoia21hcnNoYWxsIiwiYSI6ImNrdXdudGlpODI2ejkydXF2bXcyM3poaWQifQ.hyBCr6uwWlDGMGyVmuKCIw",
      map: null,
      searchTerm: null,
      searchResults: null,
      showResultsList: false,
    };
  },
  watch: {
    searchTerm() {
      this.searchPlace();
    },
  },
  methods: {
    initMap() {
      mapboxgl.accessToken = this.accessToken;

      this.map = new mapboxgl.Map({
        container: this.$refs["map-root"],
        style: "mapbox://styles/mapbox/light-v10",
        center: [-74.0133807, 40.702786],
        zoom: 15.5,
        pitch: 45,
        antialias: true,
      });

      this.map.on("load", () => {
        // Insert the layer beneath any symbol layer.
        const layers = this.map.getStyle().layers;
        const labelLayerId = layers.find(
          (layer) => layer.type === "symbol" && layer.layout["text-field"]
        ).id;

        // The 'building' layer in the Mapbox Streets
        // vector tileset contains building height data
        // from OpenStreetMap.
        this.map.addLayer(
          {
            id: "add-3d-buildings",
            source: "composite",
            "source-layer": "building",
            filter: ["==", "extrude", "true"],
            type: "fill-extrusion",
            minzoom: 15,
            paint: {
              "fill-extrusion-color": "#aaa",

              // Use an 'interpolate' expression to
              // add a smooth transition effect to
              // the buildings as the user zooms in.
              "fill-extrusion-height": [
                "interpolate",
                ["linear"],
                ["zoom"],
                15,
                0,
                15.05,
                ["get", "height"],
              ],
              "fill-extrusion-base": [
                "interpolate",
                ["linear"],
                ["zoom"],
                15,
                0,
                15.05,
                ["get", "min_height"],
              ],
              "fill-extrusion-opacity": 0.6,
            },
          },
          labelLayerId
        );
      });

      const nav = new mapboxgl.NavigationControl();
      this.map.addControl(nav, "top-right");
      this.map.scrollZoom.disable();
    },
    navigateTo(result) {
      if (result.geometry.coordinates) {
        this.map.flyTo({
          center: result.geometry.coordinates,
          zoom: 16,
          essential: true, // this animation is considered essential with respect to prefers-reduced-motion
        });
      } else {
        this.map.fitBounds(result.bbox, { zoom: 16 });
      }

      this.showResultsList = false;
    },
    searchPlace() {
      if (this.searchTerm.length > 2) {
        axios
          .get(
            `https://api.mapbox.com/geocoding/v5/mapbox.places/${this.searchTerm}.json?access_token=${this.accessToken}`
          )
          .then((response) => {
            this.searchResults = response.data.features;
            if (this.searchResults.length) {
              this.showResultsList = true;
            }
          });
      }
    },
  },
  mounted() {
    this.initMap();
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/map-shared.scss";
.gazetteer {
  z-index: 2;
  margin-top: 62px;
  padding: 1rem;
  width: 350px;
}
.list-unstyled {
  max-height: 300px;
  overflow-x: hidden;
  overflow-y: auto;

  button {
    text-align: left;
    transition: background 250ms ease;
    font-size: 0.8rem;
    &:hover {
      background: rgba(255, 255, 255, 0.05);
    }
  }
}
</style>
